module.exports = __webpack_public_path__ + "img/_icon-usps-close-x.6902a2b7.svg";